import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  routes,
  mode: 'hash',
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});
router.beforeEach(async (to, from, next) => {
  to.meta && to.meta.title && (document.title = to.meta.title);
  // to.meta.telescope && Telescope.trackPage({ trackId: to.meta.telescope });
  next();
});

export default router;
